<template>
  <div :class="[programStyle, 'flex-row']">
    <div class="table-left">
      <table>
        <tr>
          <td>Month:</td>
        </tr>
        <tr>
          <td>Status:</td>
        </tr>
        <tr>
          <td>Interference:</td>
        </tr>
        <tr>
          <td>Removal:</td>
        </tr>
      </table>
    </div>
    <div class="table-right flex-row">
      <table v-for="column in columnData" :key="column.period">
        <tr>
          <td>{{ column.period }}</td>
        </tr>
        <tr
          :class="{
            'no-si': column.mostSevereInfractionType === 'No SI',
            grace: column.mostSevereInfractionType === 'Grace',
            'follow-up': column.mostSevereInfractionType === 'Follow Up',
            'first-warning':
              column.mostSevereInfractionType === '1st Warn' ||
              column.mostSevereInfractionType === 'First' ||
              column.mostSevereInfractionType === '1',
            probation: column.mostSevereInfractionType === 'Probation',
            'penalty-and-probation':
              column.mostSevereInfractionType === 'Penalty & Probation' ||
              column.mostSevereInfractionType === 'Penalty',
            'second-warning':
              column.mostSevereInfractionType === '2nd Warn' ||
              column.mostSevereInfractionType === 'Second' ||
              column.mostSevereInfractionType === '2',
            'third-warning':
              column.mostSevereInfractionType === '3rd Warn' ||
              column.mostSevereInfractionType === 'Third' ||
              column.mostSevereInfractionType === '3',
            'fourth-warning':
              column.mostSevereInfractionType === '4th Warn' ||
              column.mostSevereInfractionType === 'Fourth' ||
              column.mostSevereInfractionType === '4',
            'fifth-warning':
              column.mostSevereInfractionType === '5th Warn' ||
              column.mostSevereInfractionType === 'Fifth' ||
              column.mostSevereInfractionType === '5',
            'sixth-warning':
              column.mostSevereInfractionType === '6th Warn' ||
              column.mostSevereInfractionType === 'Sixth' ||
              column.mostSevereInfractionType === '6',
            'seventh-warning':
              column.mostSevereInfractionType === '7th Warn' ||
              column.mostSevereInfractionType === 'Seventh' ||
              column.mostSevereInfractionType === '7',
            'eighth-warning':
              column.mostSevereInfractionType === '8th Warn' ||
              column.mostSevereInfractionType === 'Eighth' ||
              column.mostSevereInfractionType === '8',
            'ninth-warning':
              column.mostSevereInfractionType === '9th Warn' ||
              column.mostSevereInfractionType === 'Ninth' ||
              column.mostSevereInfractionType === '9',
            'tenth-warning':
              column.mostSevereInfractionType === '10th Warn' ||
              column.mostSevereInfractionType === 'Tenth' ||
              column.mostSevereInfractionType === '10',
            'tenthplus-warning':
              column.mostSevereInfractionType === '10th+ Warn' ||
              column.mostSevereInfractionType === 'Tenth+' ||
              column.mostSevereInfractionType === '10+',
          }"
        >
          <td>
            {{ column.mostSevereInfractionType }}
          </td>
        </tr>
        <tr>
          <td>{{ column.interferenceCount }}</td>
        </tr>
        <tr>
          <td>{{ column.removalCount }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ActivitySummary',
  props: {
    columnData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('global', ['programStyle']),
  },
};
</script>

<style lang="scss" scoped>
table {
  tr {
    td {
      height: 37px;
    }
  }
  border-spacing: 0px;
}
.table-left {
  table {
    width: 154px;
    background-color: #56687b;
    color: $primary-white;
    text-align: right;
    td {
      text-transform: uppercase;
      font-size: 11px;
      line-height: 20px;
      font-weight: bold;
      border-bottom: 1px solid $primary-white;
      padding-right: 10px;
    }
    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
}
.table-right {
  width: 100%;
  border-bottom: 2px solid #f5f7f8;
  table {
    width: 100%;
    tr:nth-child(2n + 1) {
      background: #f5f7f8;
    }
    tr {
      td {
        font-size: 12px;
        line-height: 11px;
        padding: 0px 10px;
      }
      &.no-si {
        background-color: #7cfe8a;
      }
      &.grace {
        background-color: #7cb8ff;
      }
      &.follow-up {
        background-color: #a7a7fd;
      }
      &.first-warning {
        background-color: #ff9c7e;
      }
      &.probation {
        background-color: #bf74ff;
      }
      &.penalty-and-probation {
        background-color: #ff9b9f;
      }
      &.second-warning,
      &.third-warning,
      &.fourth-warning,
      &.fifth-warning,
      &.sixth-warning,
      &.seventh-warning,
      &.eighth-warning,
      &.ninth-warning,
      &.tenth-warning,
      &.tenthplus-warning {
        background-color: #ff7474;
      }
    }
    tr:first-child {
      background-color: #243882;
      color: $primary-white;
      font-weight: bold;
    }
  }
}
</style>
